import { Box, Checkbox, Typography } from "@mui/material";

const ConstellationFilter = ({
  availableConstellations = [],
  enabledConstellations = [],
  selectedConstellations = [],
  activeTab,
  onToggle,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography sx={{ fontSize: "12px", mb: 1, color: "#A6B6CE" }}>
        Available Satellites
      </Typography>

      {availableConstellations.length === 0 && (
        <Typography sx={{ fontSize: "11px", color: "#777" }}>
          No constellations found
        </Typography>
      )}

      {availableConstellations.map((name) => {
        const isEnabled = enabledConstellations.includes(name);
        const isChecked = selectedConstellations.includes(name);

        return (
          <Box
            key={name}
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 1,
              opacity: isEnabled ? 1 : 0.4, // grey out disabled ones
            }}
          >
            <Checkbox
              size="small"
              disabled={!isEnabled}
              checked={isEnabled && isChecked}
              onChange={(e) => {
                if (!isEnabled) return;
                const checked = e.target.checked;
                onToggle(name, checked);
              }}
              sx={{ color: "#76b6ff", p: 0, mr: 1 }}
            />

            <Typography
              sx={{
                fontSize: "12px",
                color: isEnabled ? "#ffffff" : "rgb(218,228,243)",
              }}
            >
              {name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default ConstellationFilter;
